import { Link } from "react-router-dom";
import { entries } from "@/mocks/entries";
import EntryCard from "@/components/feature/EntryCard";
import Reveal from "@/components/base/Reveal";

export default function LatestSection() {
  const latest = [...entries]
    .sort((a, b) => (a.updated < b.updated ? 1 : -1))
    .slice(0, 6);

  return (
    <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16" aria-labelledby="home-latest-title">
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs font-medium tracking-[0.25em] text-primary-600">LATEST</p>
          <h2 id="home-latest-title" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            最近更新的汇总
          </h2>
        </div>
        <p className="max-w-xl text-sm leading-relaxed text-foreground-600">
          按最近一次更新排序。带「更新」标记的词条表示事件在整理后出现了新的公开回应。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {latest.map((entry, index) => (
          <Reveal key={entry.id} delay={index * 50}>
            <EntryCard entry={entry} />
          </Reveal>
        ))}
      </div>

      <div className="mt-8 flex justify-center">
        <Link
          to="/keywords"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-950 px-6 py-2.5 text-sm text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
        >
          进入完整索引
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}